import React, { useEffect, useState} from "react";
import { FastField } from "formik";
import { Output } from "../../Text";
import { Fieldset, Layout, FormField, Form } from "@vwfs-bronson/bronson-react";
import * as Validation from "../../validation";
import { FormSection2 } from "./FormSection";
import { Analytics } from '../../services/analytics';
import { trackAbort, trackFirstCustomerInteraction } from '../page.utils';
import { IbanField } from '../../formik/IbanField';

function PaymentSection({
  closed,
  success,
  showEditButton,
  onIconClick,
  form,
  buttons,
  containerRef,
  values,
}) {
  const [changed, setChanged] = useState(false)
  const [lastTouchedField, setLastTouchedField] = useState('')

  const defaultTrackingData = {
    [Analytics.keys.pageName()]: 'Application form',
    [Analytics.keys.viewChange()]: 'Bank account',
    [Analytics.keys.formType()]: 'Personal data',
    [Analytics.keys.formName()]: 'Bank account'
  }

  const trackPage = () => {
    setTimeout(() => {
      const pageData = {
        [Analytics.keys.eventType(0)]: 'pageView',
        [Analytics.keys.eventAction(0)]: 'Success',
      }
      Analytics.setTrackingData({...defaultTrackingData, ...pageData})
      Analytics.trackPage()
    }, 1000)
  }

  const onBlur = (ev) => {
    if (!closed && ev && ev.target && ev.target.name) {
      setLastTouchedField(ev.target.name.split('.')[ev.target.name.split('.').length - 1])
      if (!changed) {
        setChanged(true)
        trackFirstCustomerInteraction(defaultTrackingData)
      }
    }
  }

  const onUnload = () => {
    if (!closed) {
      trackAbort(lastTouchedField, defaultTrackingData)
    }
  }

  const ownUnload = () => {
    window.addEventListener('unload', onUnload)
  }

  const desubscribeUnload = () => {
    window.removeEventListener('unload', onUnload)
  }

  useEffect(() => {
    if (!closed) {
      trackPage()
      ownUnload()
      return () => {
        desubscribeUnload()
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [closed])

  return (
    <FormSection2
      containerRef={containerRef}
      title={Output.resolve("pages.applicationForm.panels.payment.title")}
      subtitle={Output.resolve("pages.applicationForm.panels.payment.subtitle")}
      success={success}
      expanded={!closed}
      onHeaderClick={onIconClick}
      edit={
        !showEditButton
          ? undefined
          : {
              label: Output.resolve("pages.applicationForm.buttonEdit"),
              onClick: onIconClick,
            }
      }
    >
      <Form {...form} onBlur={onBlur} floatingLabel>
        <Fieldset>
          <Layout>
            <Layout.Item default="6/12" m="1/2" xs="1/1">
              <FastField
                name="iban"
                label={Output.resolve(
                  "pages.applicationForm.panels.payment.fields.accountNumber.label"
                )}
                tooltip={Output.resolveAsMarkdown(
                  "pages.applicationForm.panels.payment.fields.accountNumber.toolTip"
                )}
                component={IbanField}
              />
            </Layout.Item>
            {values.bic && values.bankName && (
              <>
                <Layout.Item default="6/12" m="1/2" xs="1/1">
                  <FormField
                    type={"other"}
                    labelText={Output.resolve(
                      "pages.applicationForm.panels.payment.fields.accountNumberBic.label"
                    )}
                    noFloatingLabel
                    staticLabel
                  >
                    <div><strong>{values.bic}</strong></div>
                  </FormField>
                </Layout.Item>
                <Layout.Item default="6/12" m="1/2" xs="1/1">
                  <FormField
                    type={"other"}
                    labelText={Output.resolve(
                      "pages.applicationForm.panels.payment.fields.bankName.label"
                    )}
                    noFloatingLabel
                    staticLabel
                  >
                    <div><strong>{values.bankName}</strong></div>
                  </FormField>
                </Layout.Item>
              </>
            )}
          </Layout>
        </Fieldset>
        <Fieldset>
          <Fieldset.Row>{buttons}</Fieldset.Row>
        </Fieldset>
      </Form>
    </FormSection2>
  );
}

PaymentSection.defaultProps = {
  validate: Validation.select("iban"),
};

export default PaymentSection;
